/* Firebase Service Worker registration.
   Builds a per-load SW URL embedding the Firebase config as query params so
   the worker initializes synchronously on boot (avoids the postMessage race
   that was dropping background notifications).

   Shopify serves theme assets under `/cdn/shop/t/<id>/assets/` and does not
   emit a `Service-Worker-Allowed` header, so the browser caps the scope to
   that asset path. We deliberately let the registration take the script's
   default scope: a narrow scope still receives all Web Push events the
   subscription is associated with — scope only restricts which pages the SW
   can intercept (fetch, navigate), which is irrelevant for FCM. */

(function () {
  'use strict';

  if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
    return;
  }

  var swBaseUrl = window.__FIREBASE_SW_URL__;
  var config = window.__FIREBASE_CONFIG__;
  if (!swBaseUrl || !config || !config.apiKey || config.apiKey.indexOf('$(') === 0) {
    return;
  }

  var query = new URLSearchParams({
    apiKey: config.apiKey,
    authDomain: config.authDomain || '',
    projectId: config.projectId || '',
    storageBucket: config.storageBucket || '',
    messagingSenderId: config.messagingSenderId || '',
    appId: config.appId || ''
  }).toString();

  var swUrl = swBaseUrl + (swBaseUrl.indexOf('?') === -1 ? '?' : '&') + query;

  // Unregister stale firebase-messaging-sw registrations that were installed
  // by previous implementations (the extension bundle, the original PR 10269
  // postMessage-based SW, or older theme deploys). If we skip this, the old
  // SW keeps ownership of the PushSubscription and the browser routes pushes
  // to it — our new SW never sees them regardless of skipWaiting/claim.
  function expectedScriptUrl() {
    try {
      return new URL(swBaseUrl, window.location.origin).pathname;
    } catch (e) {
      return swBaseUrl;
    }
  }

  function cleanupStaleRegistrations() {
    return navigator.serviceWorker.getRegistrations().then(function (registrations) {
      var expectedPath = expectedScriptUrl();
      var toUnregister = [];
      for (var i = 0; i < registrations.length; i += 1) {
        var reg = registrations[i];
        var sw = reg.active || reg.installing || reg.waiting;
        if (!sw) continue;
        var url = sw.scriptURL || '';
        var isFirebaseSw = url.indexOf('firebase-messaging-sw') !== -1;
        if (!isFirebaseSw) continue;
        // Unregister if this registration does NOT point to the current theme
        // asset. Matches by pathname so the query string (per-load config)
        // is ignored.
        var regPath;
        try { regPath = new URL(url).pathname; } catch (e) { regPath = url; }
        if (regPath !== expectedPath) {
          toUnregister.push(reg);
        }
      }
      return Promise.all(toUnregister.map(function (reg) {
        return reg.unregister().catch(function () { /* ignore */ });
      }));
    }).catch(function () { /* ignore */ });
  }

  cleanupStaleRegistrations().then(function () {
    return navigator.serviceWorker.register(swUrl);
  }).then(function (registration) {
    window.__FIREBASE_SW_REGISTRATION__ = registration;
    // Force an update check on every load so a stale cached SW is replaced
    // by the latest version. Combined with skipWaiting + clients.claim in
    // the SW itself, this guarantees the active worker always has the
    // current onBackgroundMessage handler attached within a single reload.
    try { registration.update(); } catch (e) { /* ignore */ }
    window.dispatchEvent(new CustomEvent('hola:firebase-sw-ready', { detail: { registration: registration } }));
  }).catch(function (err) {
    console.warn('[firebase-sw-register] registration failed', err);
  });
})();
